import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useRecipient } from '../components/settings/shared/settings-queries';
import { homeShowsGoalPicker } from './home-goal-picker';
import { queryKeys } from './query-client';

// The phones flip their flag the moment the first workspace milestone streams in, without re-reading the
// recipient. Web does the same with its own key, kept apart from the recipient cache on purpose: the
// recipient's flag also drives the onboarding-entry route, and flipping it mid-turn would close the
// onboarding chat under the user.
export function useMarkOnboardingFinishedLive(): () => void {
  const qc = useQueryClient();
  return useCallback(() => qc.setQueryData(queryKeys.onboardingFinishedLive, true), [qc]);
}

export function useHomeShowsGoalPicker(): boolean {
  const { data: recipient, isError } = useRecipient();
  const { data: finishedLive } = useQuery({
    queryKey: queryKeys.onboardingFinishedLive,
    queryFn: () => false,
    initialData: false,
    staleTime: Infinity,
  });
  return homeShowsGoalPicker({
    known: !!recipient && !isError,
    finished: recipient?.finishedOnboarding === true || finishedLive === true,
  });
}
